(function() {
  'use strict';

  function injectStyles() {
    if (document.getElementById('l-featured-variant-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'l-featured-variant-styles';
    style.textContent = `
      /* ==================== PRICE STYLING ==================== */
      .section-l-featured-product .price,
      .section-l-featured-product .price__container {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 8px;
        margin: 16px 0;
      }

      .section-l-featured-product .price--on-sale .price__regular {
        display: none !important;
      }

      .section-l-featured-product .price--on-sale .price__sale {
        display: flex !important;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        justify-content: center;
      }

      /* Compare at price (crossed out diagonally) - purple, no opacity */
      .section-l-featured-product .price--on-sale .price-item--regular,
      .section-l-featured-product .price__sale s.price-item--regular {
        font-size: 18px !important;
        font-weight: 700 !important;
        color: #A000FF !important;
        font-family: var(--font-rubik-family) !important;
        text-decoration: none !important;
        position: relative;
        display: inline-block;
        opacity: 1 !important;
      }

      .section-l-featured-product .price--on-sale .price-item--regular::after,
      .section-l-featured-product .price__sale s.price-item--regular::after {
        content: '';
        position: absolute;
        left: -2px;
        right: -2px;
        top: 50%;
        height: 3px;
        background: #A000FF !important;
        transform: translateY(-50%) rotate(-9deg);
        transform-origin: center;
      }

      /* Sale price (current price) - dark gray */
      .section-l-featured-product .price-item--sale,
      .section-l-featured-product .price__sale .price-item--sale {
        font-size: 18px !important;
        font-weight: 700 !important;
        color: rgb(65, 64, 66) !important;
        font-family: var(--font-rubik-family) !important;
        text-decoration: none !important;
      }

      /* Regular price (when not on sale) - purple */
      .section-l-featured-product .price__regular .price-item--regular {
        font-size: 18px !important;
        font-weight: 700 !important;
        color: #a000ff !important;
        font-family: var(--font-rubik-family) !important;
        text-decoration: none !important;
      }

      /* Discount badge - purple background */
      .section-l-featured-product .badge--sale,
      .section-l-featured-product .price__badge-sale {
        padding: 4px 12px !important;
        border-radius: 24px !important;
        background: #a000ff !important;
        color: #fff !important;
        font-size: 11px !important;
        font-weight: 700 !important;
        text-transform: uppercase !important;
        letter-spacing: 0.5px !important;
        font-family: var(--font-rubik-family) !important;
        border: none !important;
      }

      /* ==================== BUY BUTTON STYLING ==================== */
      .section-l-featured-product .product-form__buttons {
        max-width: 100%;
        margin-top: 16px;
      }

      .section-l-featured-product .product-form__submit,
      .section-l-featured-product .button--primary {
        background: rgba(0, 235, 190, 1) !important;
        color: rgba(0, 82, 66, 1) !important;
        font-family: var(--font-rubik-family);
        font-weight: 700 !important;
        font-size: 16px !important;
        text-transform: uppercase !important;
        letter-spacing: 0.5px !important;
        border-radius: 50px !important;
        padding: 16px 60px 16px 32px !important;
        position: relative;
        border: none !important;
        width: 100%;
        min-height: 56px;
        transition: all 0.2s ease;
      }

      .section-l-featured-product .product-form__submit:hover,
      .section-l-featured-product .button--primary:hover {
        background: rgba(0, 210, 170, 1) !important;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 235, 190, 0.3);
      }

      .section-l-featured-product .product-form__submit::after,
      .section-l-featured-product .button--primary::after {
        content: '';
        display: block;
        position: absolute;
        right: 24px;
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.5 15L12.5 10L7.5 5' stroke='%23005242' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-size: contain;
      }

      .section-l-featured-product .product-form__submit:disabled {
        background: rgba(200, 200, 200, 1) !important;
        color: rgba(100, 100, 100, 1) !important;
      }

      .section-l-featured-product .product-form__submit:disabled::after {
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.5 15L12.5 10L7.5 5' stroke='%23646464' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
      }

      /* Dynamic checkout buttons */
      .section-l-featured-product .shopify-payment-button {
        margin-top: 12px;
      }

      .section-l-featured-product .shopify-payment-button__button {
        border-radius: 50px !important;
        min-height: 50px;
      }

      /* Loading spinner */
      .section-l-featured-product .product-form__submit .loading__spinner {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }

      .section-l-featured-product .product-form__submit .loading__spinner ~ *:not(.loading__spinner) {
        visibility: visible;
      }

      /* Form styling */
      .section-l-featured-product .product-form {
        margin-bottom: 0 !important;
      }

      /* ==================== VARIANT PICKER STYLING ==================== */
      .section-l-featured-product .product-form__input--pill,
      .section-l-featured-product .product-form__input--swatch,
      .section-l-featured-product .product-form__input--dropdown {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 16px;
      }

      .section-l-featured-product .product-form__input legend.form__label {
        font-size: 12px;
        font-weight: 700;
        color: rgba(65, 64, 66, 0.6);
        text-transform: uppercase;
        letter-spacing: 0.3px;
        margin-bottom: 8px;
      }

      /* Dropdown select styling */
      .section-l-featured-product .select select,
      .section-l-featured-product .product-form__input select {
        width: 100%;
        padding: 12px 16px;
        padding-right: 40px;
        border: 2px solid rgba(65, 64, 66, 0.1);
        border-radius: 16px;
        background: #fff;
        font-size: 14px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
        cursor: pointer;
        appearance: none;
        -webkit-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.5 13.5L15.5 18.5L10.5 13.5' stroke='%23414042' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 8px center;
        background-size: 24px;
      }

      .section-l-featured-product .select select:hover,
      .section-l-featured-product .product-form__input select:hover {
        border-color: rgba(65, 64, 66, 0.3);
      }

      .section-l-featured-product .select select:focus,
      .section-l-featured-product .product-form__input select:focus {
        border-color: rgba(0, 235, 190, 1);
        outline: none;
      }

      /* Pill/Button variant styling */
      .section-l-featured-product .product-form__input--pill input[type="radio"] + label,
      .section-l-featured-product .product-form__input--swatch input[type="radio"] + label {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 10px 20px;
        border: 2px solid rgba(65, 64, 66, 0.1);
        border-radius: 16px;
        background: #fff;
        font-size: 14px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
        cursor: pointer;
        transition: all 0.2s ease;
        min-width: 80px;
      }

      .section-l-featured-product .product-form__input--pill input[type="radio"] + label:hover,
      .section-l-featured-product .product-form__input--swatch input[type="radio"] + label:hover {
        border-color: rgba(0, 235, 190, 0.6);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 235, 190, 0.15);
      }

      .section-l-featured-product .product-form__input--pill input[type="radio"]:checked + label,
      .section-l-featured-product .product-form__input--swatch input[type="radio"]:checked + label {
        border-color: rgba(0, 235, 190, 1);
        background: rgba(255, 255, 255, 1);
      }

      /* Swatch specific styling */
      .section-l-featured-product .swatch-input__input + .swatch {
        border: 2px solid rgba(65, 64, 66, 0.1);
        border-radius: 12px;
        transition: all 0.2s ease;
      }

      .section-l-featured-product .swatch-input__input:checked + .swatch {
        border-color: rgba(0, 235, 190, 1);
        box-shadow: 0 0 0 2px rgba(0, 235, 190, 0.3);
      }

      /* Variant selects container */
      .section-l-featured-product variant-selects {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 16px 0;
        border-top: 1px solid rgba(65, 64, 66, 0.1);
        border-bottom: 1px solid rgba(65, 64, 66, 0.1);
        margin: 16px 0;
      }

      /* Hardness description styling */
      .section-l-featured-product .product-form__input_wrapper-description {
        background: rgba(65, 64, 66, 0.05);
        border-radius: 12px;
        padding: 12px 16px;
        margin-top: 8px;
      }

      .section-l-featured-product .product-form__input_wrapper-description p {
        font-size: 12px;
        color: rgba(65, 64, 66, 0.8);
        line-height: 1.5;
        margin: 0;
      }

      /* Custom dropdown redesign */
      .l-variant-dropdown-wrapper {
        position: relative;
        margin-bottom: 16px;
      }

      .l-variant-dropdown-label {
        font-size: 12px;
        font-weight: 500;
        color: rgba(65, 64, 66, 0.6);
        margin-bottom: 8px;
        display: block;
      }

      .l-variant-trigger {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 12px 16px;
        border: 2px solid rgba(65, 64, 66, 0.1);
        border-radius: 16px;
        background: #fff;
        cursor: pointer;
        transition: border-color 0.2s ease;
      }

      .l-variant-trigger:hover {
        border-color: rgba(65, 64, 66, 0.3);
      }

      .l-variant-trigger-content {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .l-variant-trigger-preview {
        width: 48px;
        height: 48px;
        border-radius: 8px;
        object-fit: cover;
        background: #f4f4f4;
        flex-shrink: 0;
      }

      .l-variant-trigger-left {
        display: flex;
        flex-direction: column;
        gap: 4px;
        text-align: left;
      }

      .l-variant-swatch {
        width: 64px;
        height: 12px;
        border-radius: 6px;
        display: inline-block;
      }

      .l-variant-value {
        font-size: 14px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
      }

      .l-variant-badge {
        display: inline-block;
        padding: 4px 12px;
        border-radius: 24px;
        background: rgba(65, 64, 66, 1);
        color: #fff;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.3px;
      }

      .l-variant-caret {
        flex-shrink: 0;
      }

      .l-variant-dropdown {
        display: none;
        position: absolute;
        top: calc(100% + 6px);
        left: 0;
        right: 0;
        background: #fff;
        border: 2px solid rgba(65, 64, 66, 0.1);
        border-radius: 16px;
        padding: 8px;
        z-index: 100;
        box-shadow: 0px 4px 6px 0px rgba(65, 64, 66, 0.2);
        max-height: 300px;
        overflow-y: auto;
      }

      .l-variant-dropdown.open {
        display: block;
      }

      .l-variant-option {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 10px 12px;
        border-radius: 12px;
        border: none;
        background: transparent;
        cursor: pointer;
        text-align: left;
        transition: background 0.15s ease;
        margin-bottom: 4px;
      }

      .l-variant-option:last-child {
        margin-bottom: 0;
      }

      .l-variant-option:hover {
        background: rgba(65, 64, 66, 0.04);
      }

      .l-variant-option.selected {
        background: rgba(244, 244, 244, 1);
      }

      .l-variant-option-preview {
        width: 48px;
        height: 48px;
        border-radius: 8px;
        object-fit: cover;
        background: #f4f4f4;
        flex-shrink: 0;
      }

      .l-variant-option-detail {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .l-variant-option-swatch {
        width: 48px;
        height: 10px;
        border-radius: 5px;
        display: inline-block;
      }

      .l-variant-option-label {
        font-size: 13px;
        font-weight: 600;
        color: #000;
      }

      .l-variant-option-badge {
        display: inline-block;
        padding: 2px 8px;
        border-radius: 24px;
        background: rgba(65, 64, 66, 1);
        color: #fff;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.3px;
      }

      /* Hide original selects when redesigned */
      .l-variant-dropdown-wrapper .product-form__input {
        position: absolute;
        left: -9999px;
        visibility: hidden;
      }

      @media (max-width: 768px) {
        .l-variant-trigger {
          padding: 10px 12px;
        }
        
        .l-variant-option {
          padding: 8px 10px;
        }
        
        .l-variant-option-preview {
          width: 40px;
          height: 40px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function getHardnessBadge(valueName) {
    const fallbackTags = {
      soft_tag: 'GENTLE',
      medium_tag: 'JUST RIGHT', 
      hard_tag: 'INTENSE'
    };
    
    const metaTags = (window.productMetafields && window.productMetafields.hardnessDescriptions) || fallbackTags;
    
    const softVariations = ['Soft', 'Mehka', 'Mekana', 'Mehke', 'Mekane', 'Miękki', 'Měkký', 'Mäkký', 'Miękkie', 'Mäkká', 'Miękka'];
    const mediumVariations = ['Medium', 'Srednja', 'Srednje', 'Średni', 'Střední', 'Stredný', 'Średnie', 'Stredná', 'Średnia'];
    const hardVariations = ['Hard', 'Trda', 'Trde', 'Tvrda', 'Tvrde', 'Twardy', 'Tvrdý', 'Twarde', 'Tvrdá', 'Twarda'];
    
    if (softVariations.includes(valueName)) {
      return metaTags.soft_tag || fallbackTags.soft_tag;
    } else if (mediumVariations.includes(valueName)) {
      return metaTags.medium_tag || fallbackTags.medium_tag;
    } else if (hardVariations.includes(valueName)) {
      return metaTags.hard_tag || fallbackTags.hard_tag;
    }
    
    return '';
  }

  function getFeaturedProductData(section) {
    if (!section) return null;
    const productJsonSelectors = [
      '[data-product-json]',
      'script[type="application/json"][id^="ProductJson"]',
      '#ProductJson-featured'
    ];

    for (const selector of productJsonSelectors) {
      const el = section.querySelector(selector) || document.querySelector(selector);
      if (!el) continue;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        console.warn('Could not parse product JSON from', selector);
      }
    }
    return null;
  }

  function syncRedesignedDropdowns(section, optionValues) {
    const wrappers = section.querySelectorAll('.l-variant-dropdown-wrapper');
    wrappers.forEach((wrapper, index) => {
      const value = optionValues[index];
      if (value == null) return;

      const btn = Array.from(wrapper.querySelectorAll('.l-variant-option')).find(
        (b) => b.dataset.value === value
      );
      if (!btn) return;

      wrapper.querySelectorAll('.l-variant-option').forEach((b) => b.classList.remove('selected'));
      btn.classList.add('selected');

      const valueEl = wrapper.querySelector('.l-variant-value');
      const labelEl = btn.querySelector('.l-variant-option-label');
      if (valueEl) valueEl.textContent = labelEl ? labelEl.textContent.trim() : value;

      const previewSrc = btn.querySelector('.l-variant-option-preview');
      const triggerPreview = wrapper.querySelector('.l-variant-trigger-preview');
      if (triggerPreview) {
        if (previewSrc && previewSrc.src) {
          triggerPreview.src = previewSrc.src;
          triggerPreview.style.display = 'block';
        } else {
          triggerPreview.style.display = 'none';
        }
      }

      const optBadge = btn.querySelector('.l-variant-option-badge');
      const badgeDisplay = wrapper.querySelector('.l-variant-badge');
      if (badgeDisplay) {
        if (optBadge) {
          badgeDisplay.textContent = optBadge.textContent;
          badgeDisplay.style.display = 'inline-block';
        } else {
          badgeDisplay.style.display = 'none';
        }
      }
    });
  }

  let observerPaused = false;

  function getUrlVariantId() {
    const params = new URLSearchParams(window.location.search || '');
    const fromQuery = params.get('variant');
    if (fromQuery) return fromQuery;
    const productInfo = document.querySelector('product-info.section-l-featured-product');
    if (productInfo && productInfo.dataset.forceVariant) return productInfo.dataset.forceVariant;
    // Support /products/x/variants/ID style paths
    const pathMatch = (window.location.pathname || '').match(/\/variants\/(\d+)/);
    return pathMatch ? pathMatch[1] : null;
  }

  function valuesMatch(a, b) {
    if (a == null || b == null) return false;
    const left = String(a).trim();
    const right = String(b).trim();
    if (left === right) return true;
    const decode = (s) => {
      const el = document.createElement('textarea');
      el.innerHTML = s;
      return el.value.trim();
    };
    return decode(left) === right || left === decode(right) || decode(left) === decode(right);
  }

  function getVariantOptionValues(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options) && variant.options.length) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter((v) => v != null && v !== '');
  }

  function findOptionControl(variantSelects, index, value) {
    const fieldset = variantSelects.querySelectorAll('fieldset.product-form__input')[index];
    if (!fieldset) return null;

    const radio = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
      (r) => valuesMatch(r.value, value) || valuesMatch(r.getAttribute('data-option-value'), value)
    );
    if (radio) return radio;

    const selectEl = fieldset.querySelector('select');
    if (!selectEl) return null;
    const option = Array.from(selectEl.options).find(
      (opt) => valuesMatch(opt.value, value) || valuesMatch(opt.getAttribute('data-option-value'), value)
    );
    return option ? { selectEl, option } : null;
  }

  function selectVariantOptions(productInfo, variant) {
    const variantSelects = productInfo.querySelector('variant-selects');
    const optionValues = getVariantOptionValues(variant);
    if (!variantSelects || !optionValues.length) return null;

    let lastChanged = null;
    optionValues.forEach((value, index) => {
      const control = findOptionControl(variantSelects, index, value);
      if (!control) return;

      if (control.tagName === 'INPUT') {
        control.checked = true;
        lastChanged = control;
        return;
      }

      control.selectEl.value = control.option.value;
      Array.from(control.selectEl.options).forEach((opt) => {
        if (opt === control.option) opt.setAttribute('selected', 'selected');
        else opt.removeAttribute('selected');
      });
      lastChanged = control.selectEl;
    });
    return lastChanged;
  }

  function collectOptionValueIds(productInfo, variant) {
    const variantSelects = productInfo.querySelector('variant-selects');
    const optionValues = getVariantOptionValues(variant);
    if (!variantSelects || !optionValues.length) return [];

    const ids = [];
    optionValues.forEach((value, index) => {
      const control = findOptionControl(variantSelects, index, value);
      if (!control) return;
      if (control.tagName === 'INPUT' && control.dataset.optionValueId) {
        ids.push(control.dataset.optionValueId);
      } else if (control.option && control.option.dataset.optionValueId) {
        ids.push(control.option.dataset.optionValueId);
      }
    });
    return ids;
  }

  function setVariantIdInputs(productInfo, variantId) {
    productInfo
      .querySelectorAll('input.product-variant-id, form[data-type="add-to-cart-form"] input[name="id"], form[action*="/cart/add"] input[name="id"]')
      .forEach((input) => {
        input.value = String(variantId);
        input.removeAttribute('disabled');
      });
  }

  /**
   * Force variant from ?variant=ID (landing pages / featured product).
   * Returns a Promise so redesign waits for the section HTML.
   */
  function applyVariantFromUrl() {
    return new Promise((resolve) => {
      const productInfo = document.querySelector('product-info.section-l-featured-product');
      const variantId = getUrlVariantId();
      if (!productInfo || !variantId) {
        resolve(false);
        return;
      }

      if (productInfo.dataset.variantUrlApplied === String(variantId)) {
        const productData = getFeaturedProductData(productInfo);
        const variant = productData && productData.variants
          ? productData.variants.find((v) => String(v.id) === String(variantId))
          : null;
        if (variant) syncRedesignedDropdowns(productInfo, getVariantOptionValues(variant));
        setVariantIdInputs(productInfo, variantId);
        resolve(true);
        return;
      }

      if (productInfo.dataset.variantUrlApplying === String(variantId)) {
        const started = Date.now();
        const wait = () => {
          if (productInfo.dataset.variantUrlApplied === String(variantId)) {
            resolve(true);
            return;
          }
          if (Date.now() - started > 5000) {
            resolve(false);
            return;
          }
          requestAnimationFrame(wait);
        };
        wait();
        return;
      }

      const productData = getFeaturedProductData(productInfo);
      const variant = productData && Array.isArray(productData.variants)
        ? productData.variants.find((v) => String(v.id) === String(variantId))
        : null;

      if (productData && !variant) {
        console.warn(
          '[l-featured-product] ?variant= not on this product:',
          variantId,
          'available:',
          productData.variants && productData.variants.map((v) => v.id)
        );
        resolve(false);
        return;
      }

      const productUrl = productInfo.dataset.url;
      const sectionId = productInfo.dataset.section;
      productInfo.dataset.variantUrlApplying = String(variantId);
      observerPaused = true;

      const finish = () => {
        setVariantIdInputs(productInfo, variantId);
        if (variant) {
          selectVariantOptions(productInfo, variant);
          syncRedesignedDropdowns(productInfo, getVariantOptionValues(variant));
        }
        productInfo.dataset.variantUrlApplied = String(variantId);
        delete productInfo.dataset.variantUrlApplying;
        observerPaused = false;
        resolve(true);
      };

      const currentId = productInfo.querySelector(
        'input.product-variant-id, form[data-type="add-to-cart-form"] input[name="id"]'
      )?.value;

      // Select matching options in the current DOM first (needed for option_value ids)
      const lastChanged = variant ? selectVariantOptions(productInfo, variant) : null;
      const optionValueIds = variant ? collectOptionValueIds(productInfo, variant) : [];

      // Liquid already has the right id — still fire change so price/media catch up
      if (String(currentId) === String(variantId)) {
        if (lastChanged) lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(finish, 400);
        return;
      }

      setVariantIdInputs(productInfo, variantId);

      if (!productUrl || !sectionId) {
        if (lastChanged) lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(finish, 300);
        return;
      }

      const params = new URLSearchParams();
      params.set('variant', String(variantId));
      params.set('section_id', sectionId);
      if (optionValueIds.length) params.set('option_values', optionValueIds.join(','));

      const fetchUrl = productUrl + (productUrl.indexOf('?') === -1 ? '?' : '&') + params.toString();

      fetch(fetchUrl, { credentials: 'same-origin' })
        .then((res) => (res.ok ? res.text() : Promise.reject(new Error('section fetch ' + res.status))))
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const source =
            doc.querySelector('#LFeaturedProduct-' + sectionId) ||
            doc.querySelector('product-info.section-l-featured-product') ||
            doc.querySelector('product-info') ||
            (doc.getElementById('shopify-section-' + sectionId) &&
              doc.getElementById('shopify-section-' + sectionId).querySelector('product-info'));

          if (source) {
            productInfo.innerHTML = source.innerHTML;
            productInfo.querySelectorAll('variant-selects').forEach((vs) => {
              vs.removeAttribute('data-redesigned');
              delete vs.dataset.redesigned;
            });
            if (variant) selectVariantOptions(productInfo, variant);
            setVariantIdInputs(productInfo, variantId);
            if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
              window.Shopify.PaymentButton.init();
            }
            finish();
            return;
          }

          console.warn('[l-featured-product] section fetch returned no product-info, using local select');
          if (lastChanged) lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
          setTimeout(finish, 500);
        })
        .catch((err) => {
          console.warn('[l-featured-product] variant apply fetch failed', err);
          if (lastChanged) lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
          setTimeout(finish, 500);
        });
    });
  }

  function redesignVariantPicker() {
    const section = document.querySelector('.section-l-featured-product');
    if (!section) return;

    const variantSelects = section.querySelector('variant-selects');
    if (!variantSelects || variantSelects.dataset.redesigned === 'true') return;

    injectStyles();

    const productData = getFeaturedProductData(section);

    // Find all fieldsets (each option)
    const fieldsets = variantSelects.querySelectorAll('fieldset.product-form__input');
    
    fieldsets.forEach((fieldset, index) => {
      // Skip if already has custom dropdown
      if (fieldset.closest('.l-variant-dropdown-wrapper')) return;

      const legend = fieldset.querySelector('legend.form__label');
      const optionName = legend ? legend.textContent.replace(/:.*/g, '').trim() : `Option ${index + 1}`;
      
      // Check if this is a color option
      const colorOptionNames = ['Colour', 'Color', 'Boja', 'Barva', 'Kolor', 'Farba', 'Barwa'];
      const isColorOption = colorOptionNames.includes(optionName);
      
      // Check if this is a hardness option
      const hardnessOptionNames = [
        'Hardness', 'Trdota ščetin', 'Bristle hardness', 'Bristles hardness',
        'Tvrdoća čekinja', 'Twardość włosia', 'Tvrdost štětin', 'Tvrdosť štetín',
        'Twardość włókien', 'Active ingredient', 'Active ingredient ',
        'Aktivni sastojak', 'Aktivna sestavina', 'Aktywny składnik',
        'Aktivní složka', 'Aktívna zložka', 'Składnik aktywny', 'Twardość szczoteczki'
      ];
      const isHardnessOption = hardnessOptionNames.includes(optionName);

      // Get select element or radio inputs
      const selectEl = fieldset.querySelector('select');
      const radioInputs = fieldset.querySelectorAll('input[type="radio"]');
      
      if (!selectEl && radioInputs.length === 0) return;

      // Create wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'l-variant-dropdown-wrapper';

      // Create label
      const label = document.createElement('span');
      label.className = 'l-variant-dropdown-label';
      label.textContent = optionName;

      // Create trigger button
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'l-variant-trigger';

      const triggerContent = document.createElement('div');
      triggerContent.className = 'l-variant-trigger-content';

      const previewImage = document.createElement('img');
      previewImage.className = 'l-variant-trigger-preview';
      previewImage.style.display = 'none';

      const triggerLeft = document.createElement('div');
      triggerLeft.className = 'l-variant-trigger-left';

      const swatchDisplay = document.createElement('span');
      swatchDisplay.className = 'l-variant-swatch';
      swatchDisplay.style.display = 'none';

      const valueDisplay = document.createElement('span');
      valueDisplay.className = 'l-variant-value';

      const badgeDisplay = document.createElement('span');
      badgeDisplay.className = 'l-variant-badge';
      badgeDisplay.style.display = 'none';

      triggerLeft.appendChild(swatchDisplay);
      triggerLeft.appendChild(valueDisplay);
      triggerLeft.appendChild(badgeDisplay);

      const caret = document.createElement('span');
      caret.className = 'l-variant-caret';
      caret.innerHTML = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5 13.5L15.5 18.5L10.5 13.5" stroke="#414042" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      triggerContent.appendChild(previewImage);
      triggerContent.appendChild(triggerLeft);
      trigger.appendChild(triggerContent);
      trigger.appendChild(caret);

      // Create dropdown
      const dropdown = document.createElement('div');
      dropdown.className = 'l-variant-dropdown';

      // Get options
      let options = [];
      if (selectEl) {
        options = Array.from(selectEl.options).map(opt => ({
          value: opt.value,
          label: opt.textContent.trim(),
          selected: opt.selected
        }));
      } else {
        options = Array.from(radioInputs).map(input => {
          const inputLabel = fieldset.querySelector(`label[for="${input.id}"]`);
          return {
            value: input.value,
            label: inputLabel ? inputLabel.textContent.trim() : input.value,
            selected: input.checked,
            swatch: inputLabel ? inputLabel.querySelector('.swatch') : null
          };
        });
      }

      // Get variant images for color options
      const variantImages = {};
      if (productData && productData.variants) {
        productData.variants.forEach(variant => {
          if (variant.featured_image) {
            const optionValue = variant.options[index];
            if (optionValue && !variantImages[optionValue]) {
              variantImages[optionValue] = variant.featured_image.src;
            }
          }
        });
      }

      // Update trigger display
      const updateTriggerDisplay = (value, label) => {
        valueDisplay.textContent = label || value;
        
        // Handle preview image for color options
        if (isColorOption && variantImages[value]) {
          previewImage.src = variantImages[value];
          previewImage.alt = label || value;
          previewImage.style.display = 'block';
        } else {
          previewImage.style.display = 'none';
        }
        
        // Handle color swatch
        const option = options.find(o => o.value === value);
        if (option && option.swatch) {
          const swatchBg = option.swatch.style.getPropertyValue('--swatch--background');
          if (swatchBg) {
            swatchDisplay.style.background = swatchBg;
            swatchDisplay.style.display = 'inline-block';
          }
        } else {
          swatchDisplay.style.display = 'none';
        }

        // Handle hardness badge
        if (isHardnessOption) {
          const badge = getHardnessBadge(label || value);
          if (badge) {
            badgeDisplay.textContent = badge;
            badgeDisplay.style.display = 'inline-block';
          } else {
            badgeDisplay.style.display = 'none';
          }
        }
      };

      // Build dropdown options
      options.forEach(opt => {
        const optionBtn = document.createElement('button');
        optionBtn.type = 'button';
        optionBtn.className = 'l-variant-option';
        if (opt.selected) {
          optionBtn.classList.add('selected');
          updateTriggerDisplay(opt.value, opt.label);
        }
        optionBtn.dataset.value = opt.value;

        // For color options, show image preview
        if (isColorOption && variantImages[opt.value]) {
          const preview = document.createElement('img');
          preview.className = 'l-variant-option-preview';
          preview.src = variantImages[opt.value];
          preview.alt = opt.label;
          optionBtn.appendChild(preview);
        }

        const detail = document.createElement('div');
        detail.className = 'l-variant-option-detail';

        // Show swatch for color options
        if (opt.swatch) {
          const optSwatch = document.createElement('span');
          optSwatch.className = 'l-variant-option-swatch';
          const swatchBg = opt.swatch.style.getPropertyValue('--swatch--background');
          if (swatchBg) {
            optSwatch.style.background = swatchBg;
            detail.appendChild(optSwatch);
          }
        }

        const labelEl = document.createElement('span');
        labelEl.className = 'l-variant-option-label';
        labelEl.textContent = opt.label;
        detail.appendChild(labelEl);

        // Show badge for hardness options
        if (isHardnessOption) {
          const badge = getHardnessBadge(opt.label);
          if (badge) {
            const badgeEl = document.createElement('span');
            badgeEl.className = 'l-variant-option-badge';
            badgeEl.textContent = badge;
            detail.appendChild(badgeEl);
          }
        }

        optionBtn.appendChild(detail);

        // Click handler
        optionBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          // Update selection
          dropdown.querySelectorAll('.l-variant-option').forEach(btn => btn.classList.remove('selected'));
          optionBtn.classList.add('selected');
          updateTriggerDisplay(opt.value, opt.label);
          dropdown.classList.remove('open');

          // Update original input
          if (selectEl) {
            selectEl.value = opt.value;
            selectEl.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            const radio = fieldset.querySelector(`input[type="radio"][value="${opt.value}"]`);
            if (radio) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });

        dropdown.appendChild(optionBtn);
      });

      // Toggle dropdown
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Close other dropdowns
        document.querySelectorAll('.l-variant-dropdown.open').forEach(d => {
          if (d !== dropdown) d.classList.remove('open');
        });
        
        dropdown.classList.toggle('open');
      });

      // Close on outside click
      document.addEventListener('click', () => {
        dropdown.classList.remove('open');
      });

      // Assemble
      wrapper.appendChild(label);
      wrapper.appendChild(trigger);
      wrapper.appendChild(dropdown);

      // Hide original fieldset and insert custom dropdown
      fieldset.style.cssText = 'position: absolute; left: -9999px; visibility: hidden;';
      fieldset.parentNode.insertBefore(wrapper, fieldset);
      wrapper.appendChild(fieldset);
    });

    variantSelects.dataset.redesigned = 'true';

    // After building dropdowns, sync trigger labels to URL variant (if any)
    const urlVariantId = getUrlVariantId();
    if (urlVariantId && productData && productData.variants) {
      const urlVariant = productData.variants.find((v) => String(v.id) === String(urlVariantId));
      if (urlVariant) syncRedesignedDropdowns(section, getVariantOptionValues(urlVariant));
    }
  }

  function reorderPriceElements() {
    const section = document.querySelector('.section-l-featured-product');
    if (!section) return;

    const priceContainer = section.querySelector('.price--on-sale');
    if (!priceContainer) return;
    
    // IMPORTANT: Check if already reordered to prevent infinite loop with MutationObserver
    if (priceContainer.dataset.reordered === 'true') return;
    
    const priceSale = priceContainer.querySelector('.price__sale');
    if (!priceSale) return;

    // Mark as reordered FIRST to prevent infinite loop
    priceContainer.dataset.reordered = 'true';

    // Find all visible span children (not visually-hidden)
    const allSpans = Array.from(priceSale.children).filter(el => 
      el.tagName === 'SPAN' && !el.classList.contains('visually-hidden')
    );
    
    if (allSpans.length < 2) return;

    // Parse prices to determine which is higher (compare) and lower (sale)
    const getPrice = (el) => {
      const text = el.textContent.replace(/[^\d.,]/g, '').replace(',', '.');
      return parseFloat(text) || 0;
    };
    
    const price1 = getPrice(allSpans[0]);
    const price2 = getPrice(allSpans[1]);
    
    let comparePriceText, salePriceText;
    
    // Higher price = compare/regular price, Lower price = sale price
    if (price1 > price2) {
      comparePriceText = allSpans[0].textContent.trim();
      salePriceText = allSpans[1].textContent.trim();
    } else {
      comparePriceText = allSpans[1].textContent.trim();
      salePriceText = allSpans[0].textContent.trim();
    }

    // Clear and rebuild the price__sale container
    priceSale.innerHTML = '';

    // 1. Regular/Compare price (crossed out, purple) - FIRST (higher price)
    const compareSpan = document.createElement('span');
    const compareS = document.createElement('s');
    compareS.className = 'price-item price-item--regular';
    compareS.textContent = comparePriceText;
    compareSpan.appendChild(compareS);
    priceSale.appendChild(compareSpan);

    // 2. Sale price (dark gray) - SECOND (lower/discounted price)
    const saleSpan = document.createElement('span');
    saleSpan.className = 'price-item price-item--sale';
    saleSpan.textContent = salePriceText;
    priceSale.appendChild(saleSpan);
  }

  function init() {
    // Always inject styles for price and button (even if no variant picker)
    const injectStylesIfSection = () => {
      const section = document.querySelector('.section-l-featured-product');
      if (section) {
        injectStyles();
      }
    };

    const runAfterVariant = () => {
      injectStylesIfSection();
      return applyVariantFromUrl().then(() => {
        redesignVariantPicker();
        const productInfo = document.querySelector('product-info.section-l-featured-product');
        const variantId = getUrlVariantId();
        if (productInfo && variantId) {
          const productData = getFeaturedProductData(productInfo);
          const variant = productData && productData.variants
            ? productData.variants.find((v) => String(v.id) === String(variantId))
            : null;
          if (variant) syncRedesignedDropdowns(productInfo, getVariantOptionValues(variant));
          setVariantIdInputs(productInfo, variantId);
        }
        reorderPriceElements();
      });
    };

    // Run on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runAfterVariant);
    } else {
      runAfterVariant();
    }

    // Also watch for dynamic content (paused while URL variant is applying)
    const observer = new MutationObserver(() => {
      if (observerPaused) return;
      runAfterVariant();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  init();
})();

